<template>
  <div @click.self="handleClick" class="__mid-div-wrapper" :style="style">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: Object
    },
    pos: {},
    isImg: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    w: {
      type: Number,
      default: 750
    },
    imgSize: {
      type: String,
      default: '100% 100%'
    },
    imgPos: {
      type: String,
      default: 'center'
    },
  },
  computed: {
    midPoint() {
      return {
        left: innerWidth / 2,
        top: innerHeight / 2
      };
    },
    scaleRate() {
      return innerWidth / this.w;
    },
    computedSize() {
      if (!this.size) {
        this.propError('size');
      }
      let { width, height } = this.size,
        rate = this.scaleRate;

      let res;

      if (Object.prototype.toString.call(this.pos) === '[object Array]') {
        let posList = this.pos.sort((item1, item2) => {
          return item1.height - item2.height;
        });
        let longRate = innerHeight / innerWidth;

        res = {
            width: rate * width,
            height: rate * height
          }

        if(longRate > posList[posList.length-1].height/this.w){
          // res需作大小变化处理
          
        }
      } else {
        res = {
              width: rate * width,
              height: rate * height
            };
      }

      return res
    },
    computedPos() {
      if (!this.pos) {
        this.propError('pos');
      }
      let { left: mL, top: mT } = this.midPoint,
        rate = this.scaleRate;

      let res ;
      if (Object.prototype.toString.call(this.pos) === '[object Array]') {
        let posList = this.pos.sort((item1, item2) => {
          return item1.height - item2.height;
        });
        let longRate = innerHeight / innerWidth;

        for (let pos of posList) {
          if (longRate <= pos.height / this.w) {
            res = {
              left: mL + pos.left*rate,
              top: mT + pos.top*rate
            };
            break;
          }
        }
        if(!res){
          // 需作位置变化处理
          res = {
              left: mL + posList[posList.length-1].left*rate,
              top: mT + posList[posList.length-1].top*rate
            };
        }
      } else {
        let { left, top } = this.pos,
        res = {
          left: mL + left * rate,
          top: mT + top * rate
        };
      }
      return res
    },
    style() {
      let computedSize = this.computedSize,
        computedPos = this.computedPos;
      let styleText = `position:absolute;
              width:${computedSize.width.toFixed(2)}px;
              height:${computedSize.height.toFixed(2)}px;
              left:${computedPos.left.toFixed(2)}px;
              top:${computedPos.top.toFixed(2)}px;
              `;
      if (!this.isImg) {
        return styleText;
      } else {
        return (
          styleText +
          `
                          background:url(${this.src});
                          background-repeat:no-repeat;
                          background-position:${this.imgPos};
                          background-size:${this.imgSize};
                          `
        );
      }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    propError(name) {
      throw Error(`Component "MidDiv" need a "${name}" prop`);
    },
    handleClick(){
      this.$emit('mclick');
    }
  }
};
</script>




<style lang="scss" scoped>
</style>
